<template>
    <div class="mask-layer mask resetMask">
        <div class="container">
            <div class="title">
                文书
            </div>
            <div class="content">
                <iframe name="pdf" width="99%" :height="myHeight" :src="myPathUrl"></iframe>
            </div>
            <div class="btn-wrap">
                <button type="button" class="btn" @click="close">返回</button>
            </div>
            <div class="close" @click="close">X</div>
        </div>
    </div>
</template>

<script>
import envConfig from "../../../common/env.js"

export default {
    name: "pdf",
    props:["pdfUrl"],
    data() {
        return {
            myHeight: "600px",
            myPathUrl: null,

        }
    },
    mounted() {
        this.myHeight = window.innerHeight - 100 + "px";
        this.myPathUrl = this.getImageUrl(this.pdfUrl) + "&=" + new Date().getTime()
    },
    methods: {
        getImageUrl(url, type) {
            let str = type ? "/file/server/file" : "/file/server/decrypt/file";
            return `${envConfig.baseUrl}${str}?path=${encodeURI(url)}`;
        },
        close() {
            this.$emit("hidePdf");
        },

    }
}
</script>
<style lang="scss" scoped>
.mask-layer {
    display: flex;
    align-items: center;
    justify-content: center;
}

.container {
    width: 100%;
    padding-bottom: 10px;
    // max-height: 650px;
    position: relative;
    box-sizing: border-box;
    overflow-y: scroll;
    background-color: #fff;

    .close {
        width: 20px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        font-size: 14px;
        position: absolute;
        top: 10px;
        right: 5px;
        cursor: pointer;
    }

    .title {
        height: 41px;
        line-height: 41px;
        box-sizing: border-box;
        padding-left: 16px;
        font-family: PingFangSC-Medium;
        font-size: 12px;
        color: #4A4A4A;
        text-align: left;
        border-bottom: 1px solid #ECF1F4;
    }

    .content {
        padding: 0px !important;
        box-sizing: border-box;
    }
}
</style>



// WEBPACK FOOTER //
// pdf.vue?0fed13c8